import React from "react";
import { Formik } from "formik";
import { z } from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";

import DaySheetForm from "./DaySheetForm";

const getInitialValues = () => {
  return {
    centerId: null,
    endTime: null,
    agentId: localStorage.getItem("cashierCRNId"),
    totalChequeAmount: 0,
    taxableAmount: 0,
    totalCashAmount: 0,
    denominationDetails: {
      count_2000: 0,
      count_1000: 0,
      count_500: 0,
      count_200: 0,
      count_100: 0,
      count_50: 0,
      count_20: 0,
      count_10: 0,
      count_5: 0,
      count_2: 0,
      count_1: 0,
    },
  };
};

const formValidationSchema = z.object({
  centerId: z
    .number()
    .nullable()
    .refine((val) => val !== null && val > 0, {
      message: "Center is required",
    }),

  endTime: z
    .string()
    .nullable()
    .refine((val) => typeof val === "string" && val.length > 0, {
      message: "End time is required",
    }),

  denominationDetails: z
    .record(
      z.string(),
      z.preprocess((val) => {
        if (val === "" || val === undefined || val === null) return 0;
        return Number(val);
      }, z.number().min(0))
    )
});

const DaySheetClosure = () => {
  return (
    <Formik
      initialValues={getInitialValues()}
      validationSchema={toFormikValidationSchema(formValidationSchema)}
    >
      {(formikProps) => {
        const { values, setFieldValue, errors, isValid, dirty, resetForm } =
          formikProps;

        return (
          <>
            <DaySheetForm
              values={values}
              setFieldValue={setFieldValue}
              errors={errors}
              isValid={isValid && dirty}
              resetForm={resetForm}
            />
          </>
        );
      }}
    </Formik>
  );
};

export default DaySheetClosure;
